export function setItem(key: string, value: string | boolean | number) {
  if (window.localStorage) {
    try {
      localStorage.setItem(key, String(value));
    } catch (error) {
      console.log('设置失败');
    }
  }
}

export function getItem(key: string) {
  if (window.localStorage) {
    try {
      const raw = window.localStorage.getItem(key);
      return raw;
    } catch (error) {
      return '';
    }
  }
  return '';
}

export function removeItem(key: string) {
  if (window.localStorage) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {}
  }
}
